import React from 'react';
import CardKeyValue from '../../../../../card/cardKeyValue';

const RolesInformation = ({ action = 'created', detail }) => {
  const { roles = [] } = detail;
  return (
    <div className='flex flex-wrap gap-4 pb-2 items-strech justify-center overflow-auto'>
      {roles?.length ? (
        roles?.map((year) => (
          <CardKeyValue
            key={year._id}
            className='min-w-100px max-w-150px'
            title={year?.name || ''}
            value={year.id || ''}
          />
        ))
      ) : (
        <></>
      )}
    </div>
  );
};

export default RolesInformation;
